import React from 'react';
import {Route} from 'react-router-dom';
// import App from "./components/App";
import Restaurant from "./components/restaurant/Restaurant";


const BaseLayout = () => (
  <div>

      <Route path="/:lang/:restaurant?" component={Restaurant}/>

  </div>
);

export default BaseLayout;



/** WEBPACK FOOTER **
 ** ./src/BaseLayout.js
 **/